import React from 'react'
import Layout from '../../Components/Layout'
import HeroGlobal from '../../Components/HeroGlobal'
import BlogDetails from '../../Components/BlogDetails'
import useDocumentTitle from '../../Hooks/PageTitle'

const BlogDetailsPage = () => {
  useDocumentTitle("TRoo Gardener | Blog Details")
  return (
    <Layout>
        <HeroGlobal title="TRoo Gardening Blogs & News"/>
        <BlogDetails/>
    </Layout>
  )
}

export default BlogDetailsPage